// Op palette shown at the current insert anchor. Lists only the ops valid for
// the frame at that position; a terminal (Metric) frame shows nothing to add.
import { chipText, validOps } from '../pipeline-compile'
import { FrameId, Op } from '../pipeline-types'
import { Action } from './store'

interface Props {
  ops: Op[]
  insertAt: number | null
  frame: FrameId
  dispatch: (a: Action) => void
}

export function OpMenu({ ops, insertAt, frame, dispatch }: Props) {
  const appending = insertAt == null || insertAt >= ops.length
  const where = appending
    ? 'append to end of chain'
    : `insert before step ${insertAt + 1} (${chipText(ops[insertAt], frame)})`
  const valid = validOps(ops, frame, insertAt ?? undefined)

  return (
    <div className="mt-2.5 flex flex-wrap items-center gap-1.5">
      <span className="mb-0.5 w-full text-xs text-fg-secondary">↳ {where}</span>
      {valid.length ? (
        valid.map((o) => (
          <button
            key={o}
            type="button"
            onClick={() => dispatch({ t: 'PICK_OP', op: o })}
            className="rounded-md border border-line bg-surface px-2.5 py-1 font-mono text-xs text-fg hover:border-brand hover:text-brand"
          >
            {o}
          </button>
        ))
      ) : (
        <span className="w-full text-xs text-fg-muted">
          ↳ frame is a single value (Metric) — terminal, no further operations
        </span>
      )}
    </div>
  )
}
